import jxWindowManager from './JxWindowManager';

import FloatingContentPanel from '../../pages/DashboardComponents/YourLibraryTab/FloatingContentPanel/FloatingContentPanel';
import JxClockOptionsDialog from '../TestWindow/JxClockOptionsDialog';
import JxClockTestForm from '../TestWindow/JxClockTestForm';
import JxStopwatchForm from '../StopwatchWidget/JxStopwatchForm';
import JxCountdownForm from '../CountdownWidget/JxCountdownForm';
import JxNoteForm from '../NoteWidget/JxNoteForm';

import TestDlg from '../../Widgets/TestDlg/TestDlg';
import LoadFormConfigDlg from '../../Widgets/FormBuilderWidget/UI/LoadFormConfigDlg/LoadFormConfigDlg';

/**
 *
 */
export default function registerDialogs() {
    jxWindowManager.registerComponent('JxClockTestForm', JxClockTestForm, JxClockOptionsDialog);
    jxWindowManager.registerComponent('FloatingContentPanel', FloatingContentPanel);
    jxWindowManager.registerComponent('JxStopwatchForm', JxStopwatchForm);
    jxWindowManager.registerComponent('JxCountdownForm', JxCountdownForm);
    jxWindowManager.registerComponent('JxNoteForm', JxNoteForm);
    jxWindowManager.registerComponent('TestDlg', TestDlg);
    jxWindowManager.registerComponent('LoadFormConfigDlg', LoadFormConfigDlg);
}
